import React, { Component } from 'react'
import { translate } from 'react-i18next'
import Error from './Error'
import Menu from './Menu'
import Spinner from './Spinner'

class LocatedMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: null,
      fetchOnInit: true // FIXME: this sux, did this because of deadline and duplicated request to api in some cases (egzample: get /pl/subpage)
    }
    
    // must be called on every component create, cos we don't know if props.menuId correspond state.location
    const location = props.t(props.location)
    props.findMenus({ target: location, location })
  }

  static getDerivedStateFromProps(props, state) {
    const location = props.t(props.location)

    // new version
    if (props.menus[location] === undefined && state.menu != null)
      return { menu: null } 

    if (props.menus[location] === undefined && state.menu === null)
      return null

    // old version
    // if (props.menus[location] === undefined)
    //   return null

    if (props.entities[props.menus[location].menuId] === undefined)
      return null

    const menu = props.entities[props.menus[location].menuId]
    const fetchOnInit = false

    return { menu, fetchOnInit }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.menu === null && this.state.fetchOnInit !== true) {
      const location = this.props.t(this.props.location)
      this.props.findMenus({ target: location, location })
    }
    // 
    // if (this.props.t(this.props.location) !== this.props.t(prevProps.location)) {
    //   const location = this.props.t(this.props.location)
    //   this.props.findMenus({ target: location, location })
    // }
  }

  render() {
    // if (this.props.code !== null && this.props.code !== 200)
    //   return <Error>{this.props.t('err.loadingMenu')}</Error>

    if (this.state.menu !== null && this.state.menu.getCode() !== 200)
      return <Error>{this.props.t('err.loadingMenu')}</Error>

    if (this.state.menu === null)
      return <Spinner>{this.props.t('msg.loadingMenu')}</Spinner>
    
    if (this.props.customMenu)
      return <this.props.customMenu items={this.state.menu.getItems()} parentProps={this.props} />

    return <Menu items={this.state.menu.getItems()} />
  }
}

export default translate()(LocatedMenu)


// WEBPACK FOOTER //
// ./src/components/LocatedMenu.js